// Syft ACP - Core <https://github.com/Syft-Application/syft2acp>
// © Syft Online Limited

import { takeEveryApiCall } from 'syft-acp-core/sagas/helpers'
import { WORKER_TIER_FETCH_BEGIN } from './action-types'

import * as api from './api'

export default function* root() {
  yield takeEveryApiCall(WORKER_TIER_FETCH_BEGIN, api.fetchWorkerTierRewards)
}
